export default __webpack_public_path__ + "static/gallery-art-printmaking-6ea9254711cb02090e949a9a2c5caa41.jpg";